export default "__VITE_ASSET__ByqUr8FH__"